import { DateTime } from 'luxon';

export const parseDate = (strDate) => {
  return DateTime.fromISO(strDate).toFormat('cccc, LLL dd');
};

export const getSessionName = (sessionName) => {
  if (!sessionName) return '';

  if (!/^[a-zA-Z_]/.test(sessionName)) return `(${sessionName})`;

  const sessionTime = sessionName.split(':');

  if (sessionTime[1]) return `(${sessionTime[1].trim()})`;

  return sessionName;
};

export const isTicketExpired = (reservationDate) => {
  const today = DateTime.now().startOf('day');
  const ticketDate = DateTime.fromISO(reservationDate).startOf('day');
  return today > ticketDate;
};

export const getCodesList = (
  tickets,
  bookingReference,
  venue,
  bundle,
  profiles = []
) => {
  if (tickets.every((ticket) => ticket.isParking))
    return tickets.map((ticket) => ({
      id: ticket.issuedCode,
      venueName: ticket.venue?.name || venue.name,
    }));

  // Season profile QR codes are only scannable on venues using the season ride scanner
  const profileCodes = venue?.useSeasonRideScanner
    ? profiles.map((profile) => ({
        id: profile.ticketId,
        venueName: venue.name,
        ticketHolder: profile.ticketHolder,
        picture: profile.picture,
        ticketName: profile.ticketName,
        isTicket: true,
      }))
    : [];

  const hasProfileCodes = profileCodes.length > 0;

  if (tickets.every((ticket) => !ticket.externalBookingId))
    return hasProfileCodes
      ? profileCodes
      : [{ id: bookingReference, venueName: venue.name }];

  const codes = tickets.reduce((acc, ticket) => {
    if (ticket.externalIds)
      acc.push(
        ...ticket.externalIds.map((id) => ({
          id,
          venueName: ticket.venue?.name || venue.name,
          isTicket: true,
        }))
      );
    else if (ticket.externalBookingId)
      acc.push({
        id: ticket.externalBookingId,
        venueName: ticket.venue?.name || venue.name,
        isTicket: true,
      });
    return acc;
  }, []);

  if (
    !hasProfileCodes &&
    (tickets.some((ticket) => !ticket.externalBookingId) ||
      tickets.every((ticket) => ticket.isPointsTicket))
  )
    codes.unshift({
      id: bookingReference,
      venueName: bundle ? bundle.title : venue.name,
    });

  return [...codes, ...profileCodes];
};
